import React, { forwardRef, useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const CommonPhoneInputs = forwardRef(
  ({ onChange, value = "", isDisable = false }, ref) => {
    useEffect(() => {
      if (ref && ref.current) {
        ref.current.focus();
      }
    }, [ref]);

    return (
      <>
        <PhoneInput
          placeholder="Enter your phone number"
          countryCallingCodeEditable={false}
          defaultCountry="US"
          international
          value={value}
          onChange={onChange}
          ref={ref}
          disabled={isDisable}
          inputProps={{
            autoComplete: "off",
          }}
        />
      </>
    );
  }
);

export default CommonPhoneInputs;
